<template>
	<div id="ChangePassword">
		<main class="main" id="top">
			<div class="container-fluid">
				<div class="row min-vh-100 flex-center g-0">
					<div class="col-lg-8 col-xxl-5 py-3 position-relative">
						<img class="bg-auth-circle-shape" src="/assets/img/icons/spot-illustrations/bg-shape.png" alt=""
							width="250">
						<img class="bg-auth-circle-shape-2" src="/assets/img/icons/spot-illustrations/shape-1.png"
							alt="" width="150">
						<div class="card overflow-hidden z-1">
							<div class="card-body p-0">
								<div class="row g-0 h-100">
									<div class="col-md-5 text-center bg-card-gradient">
										<div class="position-relative p-4 pt-md-5 pb-md-7" data-bs-theme="light">
											<div class="bg-holder bg-auth-card-shape"
												style="background-image:url(../../../assets/img/icons/spot-illustrations/half-circle.png);">
											</div>
											<!--/.bg-holder-->

											<div class="z-1 position-relative"><a
													class="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder"
													href="../../../index.html">SystemX</a>
												<div class="opacity-75 text-white" v-html="message"></div>
											</div>
										</div>
										<div class="mt-3 mb-4 mt-md-4 mb-md-5" data-bs-theme="light">
											<p class="mb-0 mt-4 mt-md-5 fs--1 fw-semi-bold text-white opacity-75"
												v-html="pass.message"></p>
										</div>
									</div>
									<div class="col-md-7 d-flex flex-center">
										<div class="p-4 p-md-5 flex-grow-1">
											<h3>
												<span v-show="recovery == false">Cambio de</span>
												<span v-show="recovery == true">Restableciendo la</span>
												Contraseña
											</h3>
											<div class="mt-3" v-show="recovery == true">
												<div class="mb-3">
													<label class="form-label">Correo
														Electronico</label>
													<input class="form-control" type="text" v-model="pass.email" />
												</div>
												<button class="btn btn-primary d-block w-100 mt-3"
													:disabled="disabledBtnSendTemporaryPassword"
													@click="sendEmailLocal">
													<span v-show="emailSent == false">Enviar</span>
													<span v-show="emailSent == true">Reenviar</span>
													código de verificación</button>
											</div>
											<div class="mt-3" v-show="emailSent == true">
												<div class="mb-3">
													<label class="form-label" for="card-password">
														<span v-show="recovery == false">Contraseña Actual</span>
														<span v-show="recovery == true">Código de Verificación</span>
													</label>
													<input class="form-control"
														:type="((recovery == false) ? 'password' : 'text')"
														v-model="pass.old" :disabled="checkingUser" />
												</div>
												<div class="mb-3">
													<label class="form-label" for="card-new-password">Nueva
														Contraseña</label>
													<input class="form-control" type="password" v-model="pass.new"
														:disabled="checkingUser" />
												</div>
												<div class="mb-3">
													<label class="form-label" for="card-new-confirm-password">Confirme
														su Nueva Contraseña</label>
													<input class="form-control" type="password" v-model="pass.repeat"
														:disabled="checkingUser" />
												</div>
												<button class="btn btn-primary d-block w-100 mt-3"
													:disabled="disabledBtnChangePassword"
													@click="changePassword">Cambiar
													Contraseña</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'

export default {
	name: 'ChangePassword',
	mixins: [mixin, axiosAction],
	props: ['action'],
	data() {
		return {
			message: '',
			pass: {
				email: '',
				old: '',
				new: '',
				repeat: '',
				message: ''
			},
			checkingUser: false,
			changingPassword: false,
			recovery: false,
			emailSent: false,
			sendingMail: false
		}
	},
	computed: {
		disabledBtnChangePassword() {
			this.pass.message = ''
			if (this.pass.old.trim().length < 6) {
				return true
			}
			if (this.pass.new.trim().length < 6) {
				return true
			}
			if (this.pass.new != this.pass.repeat) {
				return true
			}
			if (this.pass.old == this.pass.new) {
				this.pass.message = '<i class="fas fa-exclamation-triangle me-1 text-warning"></i>La nueva contraseña no puede ser igual a la antigua'
				return true
			}
			if (this.changingPassword == true) {
				this.message = ''
				return true
			}
			return false
		},
		disabledBtnSendTemporaryPassword() {
			if (!this.validateEmail(this.pass.email)) {
				return true
			}
			if (this.sendingMail == true) {
				return true
			}
			return false
		}
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'checkUserResult': this.checkUserResult(response); break;
				case 'changePasswordResult': this.changePasswordResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		initChangePassword() {
			if (this.$router.history.current.path == '/changePassword' || this.$router.history.current.path == '/changePassword/forced') {
				this.emailSent = true
				this.checkUser()
			} else if (this.$router.history.current.path == '/recoverPassword') {
				this.emailSent = false
				this.recovery = true
				this.message = 'Enviaremos un código de verificación para seguir con la recuperación de su contreña'
			}
		},
		changePassword() {
			if (!this.disabledBtnChangePassword) {
				this.changingPassword = true
				this.message = 'Estamos verificando la información de su perfil...'
				let url = this.getApiBackendNew
				url += (this.recovery == true) ? 'recoverPassword/changePassword' : 'auth/changePassword'
				this.axiosActionIS(url, 'PUT', 'changePasswordResult', this.pass)
			}
		},
		changePasswordResult(response) {
			if (response.data.success == true) {
				if (response.data.data.action == true) {
					let push = '/loading'
					this.$notify({ text: 'Listo, se cambió la contraseña con Exito!!!', type: 'success' })
					if (this.recovery == false) {
						localStorage.setItem("token", response.data.data.token)
					} else {
						push = '/login'
					}
					setTimeout(() => { this.$router.push(push) }, 1000)
				} else {
					this.changingPassword = false
					this.$notify({ text: response.data.message, type: 'warn' })
				}
			} else {
				this.changingPassword = false
				this.$notify({ text: 'No se pudo cambiar la contraseña, intentelo más tarde', type: 'error' })
			}
		},
		checkUser() {
			this.checkingUser = true
			this.message = 'Estamos verificando la información de su perfil...'
			let url = this.getApiBackendNew + 'auth/checkconection'
			this.axiosActionIS(url, 'GET', 'checkUserResult')
		},
		checkUserResult(response) {
			this.checkingUser = false
			if (response.data.success == true) {
				if (this.action == undefined) {
					this.message = 'Para cambiar su contraseña llene el formulario con todo lo que se pide.'
				} else if (this.action == 'forced') {
					this.message = 'Por su seguridad es importante que cambie la contraseña.<br>Siga los pasos para realizar el cambio'
				} else {
					this.$router.push('/unauthorized')
				}
			} else {
				console.clear()
				this.$router.push('/unauthorized')
			}
		},
		sendEmailLocal() {
			this.sendingMail = true
			let url = this.getApiBackendNew + 'recoverPassword/sendEmail'
			this.axios
				.post(url, this.pass)
				.then(response => {
					this.sendingMail = false
					if (response.data.success === true) {
						this.message = 'Hemos enviado un código de verificación para seguir con la recuperación de su contreña'
						this.$notify({ text: response.data.message, type: 'success' })
						this.emailSent = true
					} else {
						this.$notify({ text: response.data.data, type: response.data.message })
					}
				})
				.catch((response) => {
					this.sendingMail = false
					this.$notify({ text: 'Ha ocurrido un error inesperado', type: 'error' })
				})
		},
	},
	mounted() {
		this.initChangePassword()
	},
}	
</script>

<style lang="scss"></style>
